import { useTranslation } from 'react-i18next';

import type { ActionHorizon } from '@/services/complianceMonitor/complianceMonitor.types';

interface Props {
  horizon: ActionHorizon | null | undefined;
  size?: 'sm' | 'md';
}

const STYLE_BY_HORIZON: Record<ActionHorizon, string> = {
  OK: 'bg-green-50 text-green-700 border-green-200',
  URGENT_THIS_WEEK: 'bg-amber-50 text-amber-800 border-amber-200',
  SCHEDULE_NEXT_WEEK: 'bg-blue-50 text-blue-700 border-blue-200',
  NOT_FEASIBLE: 'bg-red-50 text-red-700 border-red-200',
};

export function ActionHorizonPill({ horizon, size = 'sm' }: Props) {
  const { t } = useTranslation();
  const safeHorizon: ActionHorizon = horizon ?? 'NOT_FEASIBLE';
  const cls = STYLE_BY_HORIZON[safeHorizon] ?? STYLE_BY_HORIZON.NOT_FEASIBLE;
  const padding = size === 'md' ? 'px-3 py-1' : 'px-2 py-0.5';
  return (
    <span
      className={`inline-flex items-center rounded text-xs border whitespace-nowrap font-medium ${padding} ${cls}`}
    >
      {t(`complianceMonitor.actionHorizon.${safeHorizon}`)}
    </span>
  );
}
